import { ComponentProps, createContext, useCallback, useContext, useEffect, useRef } from 'react';
import { logAnalytics } from 'shared/middlewares/analytics/logger';

type props = ComponentProps<'div'> & { name: 'advanced form' | 'essential form' | 'dynamic form' | 'batch form' };

type FormAnalyticsContext = {
  trackSubmitForm: () => void;
};

const formAnalyticsContext = createContext<FormAnalyticsContext | null>(null);

export function FormAnalyticsProvider({ name, ...props }: props) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    logAnalytics.scanForForms();
  }, []);

  const trackSubmitForm = useCallback(() => {
    if (ref.current) {
      logAnalytics.trackSubmitForm(ref.current);
    }
  }, []);

  return (
    <formAnalyticsContext.Provider value={{ trackSubmitForm }}>
      <div className="h-100" {...props} data-matomo-form data-matomo-name={name} ref={ref} />
    </formAnalyticsContext.Provider>
  );
}

export function useFormAnalytics() {
  const context = useContext(formAnalyticsContext);
  if (!context) {
    throw new Error('useFormAnalytics must be used within a FormAnalyticsProvider');
  }
  return context;
}
